import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';

import i18n from '@/locale/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'XDropdown',
  setup(__props) {

const t = i18n.global.t;
const dropdown = ref();

const onKeydown = (event: any) => {
    if (event.code === 'Enter') {
        dropdown.value.overlayVisible = false;
    }
}

const onClick = (event: any) => {
    if (!event.isTrusted) {
        dropdown.value.overlayVisible = false;
    }
}

return (_ctx: any,_cache: any) => {
  const _component_Dropdown = _resolveComponent("Dropdown")!

  return (_openBlock(), _createBlock(_component_Dropdown, {
    ref_key: "dropdown",
    ref: dropdown,
    onKeypress: _withKeys(onKeydown, ["enter"]),
    placeholder: _unref(t)('COMMON.PLACEHOLDER_SELECT'),
    onClick: onClick,
    style: {"border":"0px","border-radius":"0px","border-bottom":"1px solid #939090","background":"transparent"}
  }, {
    option: _withCtx((slotProps) => [
      _renderSlot(_ctx.$slots, "option", {
        option: slotProps.option
      })
    ]),
    value: _withCtx((slotProps) => [
      _renderSlot(_ctx.$slots, "value", {
        value: slotProps.value
      })
    ]),
    _: 3
  }, 8, ["onKeypress", "placeholder"]))
}
}

})